import get from 'lodash/get'
import partition from 'lodash/partition'
import { EMAIL_SPLIT_MODE } from 'utils/constants'

export const toProposalUpdateSerializer = proposal => {
  const {
    name,
    assignee,
    dueDate,
    followUpDate,
    signed,
    status,
    sentDate,
    value,
    sentTo,
    quoteNumber
  } = proposal
  return {
    name,
    asigneeId: assignee ? (assignee.id ? assignee.id : assignee.value) : null,
    dueDate,
    followUpDate: followUpDate || null,
    signed,
    status: get(status, 'value', status),
    sentDate,
    value: Number(value).toFixed(2),
    sentTo: get(sentTo, 'id'),
    quoteNumber
  }
}

export const toProposalFormData = (proposal, dealId, file) => {
  const formData = new FormData()
  formData.append('name', proposal.name)
  formData.append('company_id', proposal.company)
  formData.append('deal_id', dealId)
  if (file) {
    formData.append('content', file)
  }

  return formData
}

export const toProposalSerializer = proposal => {
  const { versionList } = proposal
  const list = versionList.sort((v1, v2) => (v2.version > v1.version ? 1 : -1))

  return { ...proposal, versionList: list }
}

const toContactsIdsArray = contacts => contacts.map(contact => contact.value)

const toCCRecipients = contacts => {
  return contacts.reduce((acc, cur) => {
    if (!acc[cur.type]) {
      acc[cur.type] = []
    }
    acc[cur.type].push(cur.value)
    return acc
  }, {})
}

export const toProposalEmail = (
  toContacts,
  ccContacts,
  bccContacts,
  subject,
  emailBody,
  files,
  splitMode
) => {
  const ccRecipients = ccContacts.length ? toCCRecipients(ccContacts) : []
  const [existingBccContacts, newBccContacts] = partition(bccContacts, c => !c.__isNew__)
  const bccRecipients = existingBccContacts.length ? toCCRecipients(existingBccContacts) : []

  const formData = new FormData()
  formData.append('toContacts', toContactsIdsArray(toContacts))
  formData.append('ccContacts', ccRecipients.contacts || [])
  formData.append('ccUsers', ccRecipients.users || [])
  formData.append('bccContacts', bccRecipients.contacts || [])
  formData.append('bccUsers', bccRecipients.users || [])
  formData.append('bccEmails', bccContacts ? newBccContacts.map(c => c.label) : '')
  formData.append('subject', subject)
  formData.append('emailBody', emailBody)
  formData.append('splitMode', splitMode)

  files.forEach(file => {
    formData.append('attachments', file)
  })

  return formData
}

export const toProposalContactsSelectValue = contacts =>
  contacts.map(contact => ({
    label: `${contact.firstName} ${contact.lastName}`,
    value: contact.id,
    type: 'contacts',
    email: contact.email
  }))

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName,
    type: 'users',
    email: user.email
  }))

export const toDealsByCompany = deals =>
  deals.map(deal => ({
    id: deal.id,
    name: deal.name,
    dealManager: deal.dealManager,
    status: deal.status
  }))

export const fromProposals = proposals =>
  proposals.map(proposal => ({
    id: proposal.id,
    name: proposal.name
  }))

export const toProposalHistoryContacts = contacts =>
  contacts.map(contact => {
    const { proposalReceivedDate, proposalSentDate } = contact
    const { id, firstName, lastName } = contact.contact
    return {
      id,
      firstName,
      lastName,
      proposalReceivedDate,
      proposalSentDate
    }
  })

export const toProposalReviewersSerializer = users => ({
  ids: users.map(user => user.value),
  splitMode: Object.keys(EMAIL_SPLIT_MODE)[0]
})
